import { TeamId } from '@/react/portainer/users/teams/types';

import { useAddons } from './useAddons';

/**
 * Whether the team can reach an enabled add-on. The deny-Portainer setting gates
 * on this so denied members aren't sent into a gateway 403. Team grants live on
 * the admin-only `record`, so this is false for a non-admin.
 */
export function useTeamHasEnabledAddonAccess(teamId: TeamId) {
  const addonsQuery = useAddons({
    select: (data) =>
      Boolean(
        data?.addons?.some(
          (addon) => addon.enabled && addon.record?.teamAccessPolicies?.[teamId]
        )
      ),
  });

  return addonsQuery.data ?? false;
}
